import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { HorariosPageQuery, HorariosPageQueryVariables } from './__generated__/HorariosPageQuery';

const HORARIOS_QUERY = gql`
  query HorariosPageQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    horarios(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_horario
      hora_inicio
      hora_fim
    }
  }
`;

const useHorariosPageQuery = (variables: HorariosPageQueryVariables) => {
  return useQuery<HorariosPageQuery, HorariosPageQueryVariables>(HORARIOS_QUERY, {
    variables,
  });
};

const useHorariosLazyQuery = () => {
  return useLazyQuery<HorariosPageQuery, HorariosPageQueryVariables>(HORARIOS_QUERY);
};

export { useHorariosPageQuery, useHorariosLazyQuery };
